import OptimizedImage from '../../../../OptimizedImage'
import ChevronRightIcon from '../../../../icons/ChevronRightIcon'
import React, { useState } from 'react'
import styles from './styles.module.css'

const cx = (...c) => c.filter(Boolean).join(' ')

function Carousel({ images }) {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const handleCarouselArrowClick = (direction) => {
    if (direction === 'next') {
      setSelectedIndex(selectedIndex === images.length - 1 ? 0 : selectedIndex + 1)
    }
    if (direction === 'prev') {
      setSelectedIndex(selectedIndex === 0 ? images.length - 1 : selectedIndex - 1)
    }
  }

  if (!images) {
    return null
  }

  return (
    <div className={styles.carouselWrapper}>
      {
        // render all images and a "fake" one at the end:
        // - the "fake" one will never be reached, because the carousel stops when it reaches the length of the original images array
        // - the "fake" will keep the height of the carousel between renders
        images.concat({ src: images[0].placeholderSrc }).map((image, index) => (
          // Key by positional index: all gallery images of one product share the
          // same `alt` (e.g. "R295 Steering Wheel"), so keying on `alt` produced
          // duplicate keys ("Encountered two children with the same key") — a
          // first-party console.error the #114 gate reds (#127). The carousel is
          // a fixed positional list, so the index is a stable, unique key.
          <div className={styles.imageWrapper}
               key={index}
               style={{ opacity: index === selectedIndex ? 1 : 0 }}>
            {/* Forward the FULL ResolvedImage descriptor (srcSet + width/height +
                placeholder), not just a bare src — so <Img> serves the responsive
                variant ladder and reserves the aspect-ratio box (no CLS on load).
                Falls back to the legacy { src, placeholderSrc } trio for any bare
                entry. See lib/resolveImage.js / components/Img (task #67/#74). */}
            <OptimizedImage
              image={image}
              src={image?.src}
              placeholderSrc={image?.placeholderSrc}
              alt={image?.alt || ''}
              sizes="(max-width: 991px) 100vw, 720px"
              reserveSpace={false}
            />
          </div>
        ))
      }
      {
        images.length > 1 && <>
          <div className={styles.carouselArrow} onClick={() => handleCarouselArrowClick('prev')}><ChevronRightIcon/></div>
          <div className={cx(styles.carouselArrow, styles.carouselArrowRight)} onClick={() => handleCarouselArrowClick('next')}><ChevronRightIcon/></div>
        </>
      }
    </div>
  )
}

export default Carousel
